module.exports = __webpack_public_path__ + "static/media/logo.b89825c1.jpg";